import React, { useContext } from 'react';
import { Stack, mergeStyles } from '@fluentui/react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const stackStyles = {
  root: {
    marginTop: 64,
    marginBottom: 48,
  },
};

const spinnerStyles = mergeStyles({
  marginBottom: 12,
});

const loadingMessageStyles = mergeStyles({
  fontWeight: 600,
  fontSize: 16,
  lineHeight: 22,
});

export const ApplyingChanges = () => {
  const i18n = useContext(I18nContext);
  return (
    <div className="applying-autobidding-changes">
      <Stack horizontalAlign="center" verticalAlign="top" styles={stackStyles}>
        <Spinner size={SpinnerSize.large} className={spinnerStyles} />
        <div className={loadingMessageStyles}>
          {i18n.getString(_TL_('We\'re applying your bid strategy.'))}
        </div>
      </Stack>
    </div>
  );
};
